import { render } from "./NuovoProdotto.vue?vue&type=template&id=5d931057&scoped=true"
import script from "./NuovoProdotto.vue?vue&type=script&lang=js"
export * from "./NuovoProdotto.vue?vue&type=script&lang=js"

import "./NuovoProdotto.vue?vue&type=style&index=0&id=5d931057&lang=css"
import "./NuovoProdotto.vue?vue&type=style&index=1&id=5d931057&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d931057"]])

export default __exports__